

















import { Component, Vue, Watch } from 'vue-property-decorator';
import Icon from '@/components/common/icon.vue';
import EventBus from '@/event-bus';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import { Route } from 'vue-router';
import { ConfigsModuleMapper } from '@/store/modules/config';

const Mappers = Vue.extend({
  computed: {
    ...ConstantsModuleMapper.mapState([
      'list',
    ]),
    ...ConfigsModuleMapper.mapState([
      'returnFromSearch',
    ]),
  },
  methods: {
    ...ConfigsModuleMapper.mapMutations({
      setFromSearch: 'setFromSearch',
    }),
  },
});

@Component({
  props: {
    isOpened: Boolean,
  },
  components: {
    Icon,
  },
})
export default class SearchBarPanelComponent extends Mappers {
  isFocused = false;

  searchText = '';

  @Watch('isOpened')
  onIsShownChanged(isOpened: boolean) {
    if (isOpened) {
      Vue.nextTick(() => {
        (this.$refs.input as HTMLElement).focus();
      });
    }
  }

  created() {
    this.searchText = (this.$route.query?.query as string) || '';
  }

  @Watch('$route')
  changeHeaderText(route: Route) {
    if (route.name !== 'search' && !this.returnFromSearch) {
      this.searchText = '';
      this.$emit('close');
    }
    if (route.name !== 'search' && this.returnFromSearch && window.innerWidth < 768) {
      this.$emit('close');
    } else if (route.name === 'search' && window.innerWidth < 768 && !!this.searchText) {
      this.$emit('toggle', true);
    }
  }

  get disabled() {
    return this.searchText.trim().length < 3;
  }

  focusInput(state: boolean) {
    this.isFocused = state;
  }

  get valueLength() {
    return !!this.searchText.trim().length;
  }

  clear() {
    this.searchText = '';
  }

  search() {
    if (this.searchText.trim().length && !this.disabled) {
      const query = { query: this.searchText, page: '0' };
      this.setFromSearch(false);
      if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        this.$router
          .push({ path: '/search', query })
          .catch(() => {
            // ToDo remove in next iteration
            // console.warn('goto', e);
          });
      }
      EventBus.$emit('search', query);
    }
  }
}
